import React, { FC, ReactElement, ReactNode, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import { FormTabHeader } from 'ra-ui-materialui/lib';
import { FormGroupContextProvider, Record } from 'ra-core';

const hiddenStyle = { display: 'none' };

const ViewTab: FC<ViewTabProps> = ({
  className,
  classes = {},
  contentClassName,
  children,
  hidden,
  icon,
  intent,
  label,
  margin,
  path,
  variant,
  value,
  selected,
  ...rest
}) => {
  const [tabLoaded, setTabLoaded] = useState(false);

  // mandatory to add the if so it goes only one time inside when we load for the first time.
  useEffect(() => {
    if (!tabLoaded) {
      setTabLoaded(!hidden);
    }
  }, [hidden, tabLoaded]);

  const renderHeader = () => (
    <FormTabHeader
      label={label}
      value={value}
      icon={icon}
      className={className}
      classes={classes}
      {...omit(rest, [
        'showNotification',
        'hasCreate',
        'hasShow',
        'hasEdit',
        'hasList',
        'basePath'
      ])}
    />
  );

  // By this condition into the renderContent, we can add a lazy loading to not load all of the tabs into the User screen for example.
  // So it only call the api where we are currently into the tab.
  const renderContent = () => {
    if (tabLoaded) {
      return (
        <FormGroupContextProvider name={value.toString()}>
          <span
            style={hidden ? hiddenStyle : null}
            className={contentClassName}
          >
            {children}
          </span>
        </FormGroupContextProvider>
      );
    } else {
      return <></>;
    }
  };

  return intent === 'header' ? renderHeader() : renderContent();
};

ViewTab.propTypes = {
  basePath: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  intent: PropTypes.oneOf(['header', 'content']),
  hidden: PropTypes.bool,
  icon: PropTypes.element,
  label: PropTypes.string.isRequired,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  path: PropTypes.string,
  // @ts-ignore
  record: PropTypes.object,
  resource: PropTypes.string,
  value: PropTypes.string,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
};

export interface ViewTabProps {
  basePath?: string;
  className?: string;
  classes?: object;
  children?: ReactNode;
  contentClassName?: string;
  hidden?: boolean;
  selected?: boolean;
  icon?: ReactElement;
  intent?: 'header' | 'content';
  label: string | ReactElement;
  margin?: 'none' | 'normal' | 'dense';
  path?: string;
  record?: Record;
  resource?: string;
  syncWithLocation?: boolean;
  value?: string;
  variant?: 'standard' | 'outlined' | 'filled';
}

ViewTab.displayName = 'ViewTab';

export default ViewTab;
